import ace from 'ace-builds'
import modeIniUrl from 'ace-builds/src-noconflict/mode-ini?url'
import modeJsonUrl from 'ace-builds/src-noconflict/mode-json?url'
import modePlainTextUrl from 'ace-builds/src-noconflict/mode-plain_text?url'
import modeTextUrl from 'ace-builds/src-noconflict/mode-text?url'
import modeTomlUrl from 'ace-builds/src-noconflict/mode-toml?url'
import modeYamlUrl from 'ace-builds/src-noconflict/mode-yaml?url'
import themeMonokaiUrl from 'ace-builds/src-noconflict/theme-monokai?url'

import { normalizeFileEditorLang } from './fileEditorLang'

let aceFileEditorAssetsRegistered = false

export function registerFileEditorAceAssets() {
  if (aceFileEditorAssetsRegistered) return

  ace.config.setModuleUrl('ace/mode/ini', modeIniUrl)
  ace.config.setModuleUrl('ace/mode/json', modeJsonUrl)
  ace.config.setModuleUrl('ace/mode/plain_text', modePlainTextUrl)
  ace.config.setModuleUrl('ace/mode/text', modeTextUrl)
  ace.config.setModuleUrl('ace/mode/toml', modeTomlUrl)
  ace.config.setModuleUrl('ace/mode/yaml', modeYamlUrl)
  ace.config.setModuleUrl('ace/theme/monokai', themeMonokaiUrl)

  aceFileEditorAssetsRegistered = true
}

export { normalizeFileEditorLang }
